export default "__VITE_ASSET__Bs97F7nQ__"